var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { cn } from "../../lib/utils.js";
// Progress component styled to match the refined UI design
var Progress = React.forwardRef(function (_a, ref) {
    var className = _a.className, _b = _a.type, type = _b === void 0 ? 'linear' : _b, _c = _a.value, value = _c === void 0 ? 0 : _c, _d = _a.max, max = _d === void 0 ? 100 : _d, _e = _a.trackColor, trackColor = _e === void 0 ? 'rgba(36,36,36,0.2)' : _e, _f = _a.fillColor, fillColor = _f === void 0 ? '#756A67' : _f, _g = _a.height, height = _g === void 0 ? 4 : _g, _h = _a.size, size = _h === void 0 ? 144 : _h, _j = _a.strokeWidth, strokeWidth = _j === void 0 ? 8 : _j, centerLabel = _a.centerLabel, bottomLabel = _a.bottomLabel, props = __rest(_a, ["className", "type", "value", "max", "trackColor", "fillColor", "height", "size", "strokeWidth", "centerLabel", "bottomLabel"]);
    var percentage = Math.max(0, Math.min(100, (value / max) * 100));
    if (type === 'circular') {
        var radius = (size - strokeWidth) / 2;
        // Use 270 degrees (3/4 circle) instead of full circle
        var arcLength = 2 * Math.PI * radius * 0.75; // 75% of full circle
        var offset = arcLength * (1 - percentage / 100);
        return (_jsx("div", __assign({ ref: ref, className: cn('inline-flex flex-col items-center', className), style: { width: "".concat(size, "px") } }, props, { children: _jsxs("div", { className: "relative", style: { width: "".concat(size, "px"), height: "".concat(size, "px") }, children: [_jsxs("svg", { width: size, height: size, className: "drop-shadow-sm", children: [_jsx("circle", { cx: size / 2, cy: size / 2, r: radius, fill: "none", stroke: trackColor, strokeWidth: strokeWidth, strokeDasharray: "".concat(arcLength, " ").concat(2 * Math.PI * radius), strokeLinecap: "round", transform: "rotate(135 ".concat(size / 2, " ").concat(size / 2, ")") }), _jsx("circle", { cx: size / 2, cy: size / 2, r: radius, fill: "none", stroke: fillColor, strokeWidth: strokeWidth, strokeDasharray: "".concat(arcLength, " ").concat(2 * Math.PI * radius), strokeDashoffset: offset, strokeLinecap: "round", transform: "rotate(135 ".concat(size / 2, " ").concat(size / 2, ")"), style: {
                                    transition: 'stroke-dashoffset 0.5s ease-in-out',
                                } })] }), centerLabel && (_jsx("div", { className: "absolute inset-0 flex items-center justify-center", children: _jsx("div", { className: "text-center", style: { marginTop: '-8px' }, children: _jsx("div", { className: "text-2xl font-semibold text-gray-900 dark:text-foreground leading-none", children: centerLabel }) }) })), bottomLabel && (_jsx("div", { className: "absolute text-center text-sm font-medium text-gray-600 dark:text-muted-foreground", style: {
                            bottom: "".concat(strokeWidth * 1, "px"),
                            left: '50%',
                            transform: 'translateX(-50%)',
                            width: 'max-content'
                        }, children: bottomLabel }))] }) })));
    }
    // Linear bar fallback
    return (_jsx("div", __assign({ ref: ref, className: cn('relative w-full overflow-hidden', className), style: {
            height: "".concat(height, "px"),
            backgroundColor: trackColor,
            borderRadius: "".concat(height * 4, "px"),
        } }, props, { children: _jsx("div", { className: "absolute top-0 left-0 h-full", style: {
                width: "".concat(percentage, "%"),
                backgroundColor: fillColor,
                borderRadius: "".concat(height * 4, "px"),
                transition: 'width 0.3s ease-in-out',
            } }) })));
});
Progress.displayName = "Progress";
export { Progress };
